import React from "react"

import { Dropdown } from "antd"
import { useTranslation } from "react-i18next"

import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import Icon from "../../Icon"
import Button from "../Button"

const defaultItems = [
  {
    key: "all",
    label: "Export all"
  },
  {
    key: "as_filtered",
    label: "Export as filtered"
  }
]

const ExportDropdown = ({
  loading,
  onExport,
  isAdmin,
  disabled,
  items = defaultItems,
  exportAsFiltered,
  iconButton = false,
  fullWidths = false,
  inHeader = false
}) => {
  const { t } = useTranslation()
  const externalDemoMode = useExternalDemoMode()

  const updatedItems = items.map((item) => ({ ...item, disabled }))

  if ((isAdmin || exportAsFiltered) && !externalDemoMode) {
    return (
      <Dropdown
        overlayClassName="custom-menu"
        getPopupContainer={() => document.getElementById("main-layout")}
        menu={{
          //items: items.map(item => ({...item, label: t(item.label)})),
          items: updatedItems,
          onClick: ({ key }) => onExport(key)
        }}
        trigger={["click"]}
        placement="bottomLeft"
      >
        <div className="edit-columns-trigger" onClick={(e) => e.stopPropagation()}>
          <Button
            className={`flex center ${iconButton && !inHeader && "isMobile"}`}
            loading={loading}
            style={{ minHeight: 40 }}
            icon={<Icon type="file_download" style={{ fontSize: 20, transform: "rotate(0deg)" }} />}
          >
            {!iconButton && !inHeader && t("Export")}
          </Button>
        </div>
      </Dropdown>
    )
  } else {
    return (
      <Button
        icon={<Icon type="file_download" style={{ fontSize: 20 }} />}
        className={`flex center ${iconButton && !inHeader && "isMobile"}`}
        loading={loading}
        disabled={disabled || externalDemoMode}
        onClick={(event) => {
          event.stopPropagation()
          onExport("all")
        }}
        style={{
          minHeight: 40,
          width: fullWidths && "100%",
          height: fullWidths && 40,
          marginBottom: fullWidths && 12
        }}
      >
        {!iconButton && !inHeader && t("Export")}
      </Button>
    )
  }
}

export default React.memo(ExportDropdown)
